import { gql } from "@apollo/client";

export const DISABLE_MEMBER_USER = gql`
  mutation DisableMemberUser($id: ID!) {
    disableMemberUser(id: $id)
  }
`;